import React, { useState, useEffect } from "react";
import InspirationalCorner from "./InspirationalCorner";
import Faqs from "./Faqs";
import Tutorials from "./Tutorials";

// Modal Imports
import AddTutorialModal from "../Modals/AddTutorialModal";
import AddInspirationalVideo from "../Modals/AddInspirationalVideo";
import AddFaqsModal from "../Modals/AddFaqsModal";
import UploadReadOnlyVideoModal from "../Modals/UploadReadOnlyVideoModal";

import styles from "../../_css/ContenetManagement.module.css";
import { useLocation } from "react-router";

const ContentManagement = () => {
    const location = useLocation();
    console.log(location.state?.activeTab)
    const [activeFilter, setActiveFilter] = useState(location.state?.activeTab || "Inspirational Corner");
    // Modal Visibility
    const [showFaqModal, setShowFaqModal] = useState(false);
    const [showTutorialModal, setShowTutorialModal] = useState(false);
    const [showInspirationalModal, setShowInspirationalModal] = useState(false);
    const [showReadOnlyVideoModal, setShowReadOnlyVideoModal] = useState(false);
    const [dataFetch, setDataFetch] = useState(false);

    // Reset dataFetch when it's used to trigger refresh
    useEffect(() => {
        if (dataFetch) {
            // Reset after a short delay to allow components to detect the change
            const timer = setTimeout(() => {
                setDataFetch(false);
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [dataFetch]);

    const handleAddClick = () => {
        if (activeFilter === "Inspirational Corner") {
            setShowInspirationalModal(true);
        } else if (activeFilter === "FAQs") {
            setShowFaqModal(true);
        } else if (activeFilter === "Tutorial") {
            setShowReadOnlyVideoModal(true);
        }
    };

    const handleSuccess = () => {
        setDataFetch(prev => !prev);
    };

    const filterTabs = [
        { id: "inspirational-corner", label: "Inspirational Corner", active: true },
        { id: "faq", label: "FAQs", active: false },
        { id: "tutorial", label: "Tutorial", active: false },
    ];

    return (
        <div className={styles.container}>
            {/* Header */}
            <div style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
            }}>
                {/* Filter Tabs */}
                <div className={styles.filterTabs}>
                    {filterTabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveFilter(tab.label)}
                            className={`${styles.tabButton} ${activeFilter === tab.label ? styles.activeTab : ""
                                }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                {/* Add Button */}
                <button
                    onClick={handleAddClick}
                    className={styles.addButton}
                >
                    Add
                </button>
            </div>

            {/* Components */}
            {
                activeFilter === "Inspirational Corner" ? (
                    <InspirationalCorner dataFetch={dataFetch} />
                ) : activeFilter === "FAQs" ? (
                    <Faqs dataFetch={dataFetch} />
                ) : (
                    <Tutorials dataFetch={dataFetch} />
                )
            }

            {/* Render Modals */}
            <AddFaqsModal
                show={showFaqModal}
                onHide={() => setShowFaqModal(false)}
                onSuccess={() => {
                    setShowFaqModal(false);
                    handleSuccess();
                }}
            />

            <AddInspirationalVideo
                show={showInspirationalModal}
                onHide={() => setShowInspirationalModal(false)}
                onSuccess={handleSuccess} // Add onSuccess if inspirational modal supports it
            />

            {/* <AddTutorialModal show={showTutorialModal} onHide={() => setShowTutorialModal(false)} /> */}

            <UploadReadOnlyVideoModal
                show={showReadOnlyVideoModal}
                onSuccess={() => {
                    setShowReadOnlyVideoModal(false);
                    handleSuccess();
                }}
                onHide={() => setShowReadOnlyVideoModal(false)}
            />
        </div >
    );
};

export default ContentManagement;